import React from 'react';

import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';
import EmptyOption from './EmptyOption';

const FieldSelect = ({
  className,
  classInvalid,
  label,
  list,
  name,
  placeholder,
  required,
  isDisabled,
  keyName,
  keyLabel,
  onChangeCallback,
}) => {
  const { setFieldValue, values, errors, touched, validateForm } = useFormikContext();
  const onChange = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setFieldValue(name, value);
    if (onChangeCallback) {
      onChangeCallback(value, setFieldValue, validateForm);
    }
  };
  return (
    <div className={className}>
      {label && (
        <label htmlFor={name}>
          {label}
          {required && <span className="color-red">&nbsp;*</span>}
        </label>
      )}
      {errors[name] && touched[name] && <div className={classInvalid}>{errors[name]}</div>}
      {!errors[name] && touched[name] && <div className="field-valid">ok</div>}
      <Field
        disabled={isDisabled}
        as="select"
        onChange={onChange}
        value={values[name]}
        name={name}>
        <EmptyOption label={placeholder} />
        {list.length > 0 && list.map((item) => (
          <option
            key={`${item[keyName]}-${keyLabel}`}
            value={item[keyName]}>
            {keyLabel ? item[keyLabel] : item[keyName]}
          </option>
        ))}
      </Field>
    </div>
  );
};

FieldSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  list: PropTypes.array.isRequired,
  className: PropTypes.string,
  classInvalid: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  keyName: PropTypes.string,
  keyLabel: PropTypes.string,
  onChangeCallback: PropTypes.func,
};

FieldSelect.defaultProps = {
  className: 'field',
  classInvalid: 'field-invalid',
  label: '',
  placeholder: 'Seleccionar',
  required: false,
  isDisabled: false,
  keyName: 'value',
  keyLabel: '',
  onChangeCallback: null,
};

export default FieldSelect;
